import firebase from 'firebase';
import 'firebase/firestore';
import "firebase/auth";

//This is my firebase authentication
//you can change it to your firebase authentication
var firebaseApp = {
    apiKey: "AIzaSyCdV6fcxkByyQDdfjTKPcWLigY0JTgyIp0",
    authDomain: "zhenying-chen.firebaseapp.com",
    databaseURL: "https://zhenying-chen-default-rtdb.firebaseio.com",
    projectId: "zhenying-chen",
    storageBucket: "zhenying-chen.appspot.com",
    messagingSenderId: "238841429322",
    appId: "1:238841429322:web:d6a8b649b63eb0070b55b3",
    measurementId: "G-8LBBNSZBJM"
};

firebase.initializeApp(firebaseApp);
const database = firebase;

export const auth = firebase.auth();
export const firestore = firebase.firestore();

const provider = new firebase.auth.GoogleAuthProvider();
provider.setCustomParameters({ prompt: "select_account" });
export const signInWithGoogle = () => auth.signInWithPopup(provider);

export default database;